module.exports = __webpack_public_path__ + "img/nt15-13-75-1.prt.3e7f35c6.jpg";